import {ReactComponent as MariaDBIcon} from '../assets/design-system/db-type/maria-db.svg';
import {ReactComponent as MSSQLIcon} from '../assets/design-system/db-type/ms-sql.svg';
import {ReactComponent as MySQLIcon} from '../assets/design-system/db-type/my-sql.svg';
import {ReactComponent as OracleIcon} from '../assets/design-system/db-type/oracle.svg';
import {ReactComponent as PostgreSQLIcon} from '../assets/design-system/db-type/postgre-sql.svg';
import {ReactComponent as SQLiteIcon} from '../assets/design-system/db-type/sqlite.svg';

const getDBTypeIcon = (dbType, style) => {
    switch (dbType) {
        case 'MARIADB':
            return <MariaDBIcon style={style} />;
        case 'MSSQL':
            return <MSSQLIcon style={style} />;
        case 'MYSQL':
            return <MySQLIcon style={style} />;
        case 'ORACLE':
            return <OracleIcon style={style} />;
        case 'POSTGRESQL':
            return <PostgreSQLIcon style={style} />;
        case 'SQLITE':
            return <SQLiteIcon style={style} />;
        case null:
            return null;
        default:
            return 'DB 타입 아이콘';
    }
};

export default getDBTypeIcon;
